var API_DOMAIN = "api.cubewanos.erdmanczyk.com";
var COREID = "e00fce68402ff02444f78689";

export {API_DOMAIN, COREID};
